<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <div
      :class="$style.btLuckyTurntable"
      id="headerTop"
      :style="{
        backgroundImage: `url(${cdnLink.CDN_URL_1}/box_turntable/btTurntablePage2.jpg)`,
      }"
    >
      <!-- <img
        :class="$style.pageBack"
        :src="cdnLink.CDN_URL_1 + `/box_turntable/btTurntablePage2.jpg`"
      /> -->
      <div :class="$style.pageContent">
        <!-- 游戏下载 -->
        <div :class="$style.gameBox">
          <img :src="gameInfo.logo" alt="" :class="$style.icon" />
          <div :class="$style.info">
            <p :class="$style.name">{{ gameInfo ? gameInfo.appName : "" }}</p>
            <p :class="$style.tags">
              <span
                v-for="item in gameInfo.tags"
                :key="item.id"
                :style="{ color: item.labelInfo }"
                >{{ item.labelName }}</span
              >
            </p>
          </div>
          <button
            :class="$style.download"
            @click="onGoGameDetail({ ...gameInfo, type: 1 })"
          >
            查看/下载
          </button>
        </div>
        <div :class="$style.luckyWheelBox">
          <!-- 账号信息 -->
          <div :class="$style.userInfo">
            <div :class="$style.account">
              账号：{{ turntableInfo.username }}
            </div>
            <div :class="$style.info">
              <a @click="onNavigateToPage('活动规则')">活动规则</a
              ><a @click="onNavigateToPage('领取记录')">领取记录</a>
            </div>
          </div>
          <div :class="$style.notice">
            <div>
              <p>{{ turntableInfo.appContent }}</p>
            </div>
          </div>
          <!-- 抽奖机会 -->
          <div :class="$style.drawNum">剩余抽奖次数：{{ curNum }}</div>
          <div :class="$style.desc">抽奖次数于次日重置</div>
          <!-- 抽奖转盘 -->
          <LuckyWheel
            ref="myLucky"
            width="300px"
            height="300px"
            :prizes="prizes"
            :blocks="blocks"
            :buttons="buttons"
            :defaultConfig="defaultConfig"
            @start="startCallback"
            @end="endCallback"
          />
          <div :class="$style.rewardInfo" @click="onRewardDetail">
            查看奖品明细
          </div>
          <div :class="$style.drawNum" :style="{ marginTop: '12px' }">
            完成任务领更多抽奖次数
          </div>
        </div>
        <!-- 任务 -->
        <div :class="$style.taskBox">
          <div v-for="task in taskList" :key="task.id" :class="$style.task">
            <img
              :class="$style.taskIcon"
              :src="cdnLink.CDN_URL_1 + `/box_turntable/taskIcon.png`"
            />
            <div :class="$style.taskInfo">
              <p :class="$style.taskType">{{ task.type }}</p>
              <p :class="$style.num">抽奖次数+{{ task.rewardNum }}</p>
            </div>
            <button
              @click="onCompleteTask(task)"
              :class="`${$style.taskBtn} ${
                task.receiveStatus ? $style.statusBtn : ''
              }`"
            >
              {{ task.receiveStatus ? "已" : "" }}领取
            </button>
          </div>
        </div>
      </div>

      <!-- 弹窗 -->
      <div :class="$style.dialog" v-if="dialogVisible">
        <header>
          <span>{{ dialogBtnText[dialogType].title }}</span>
          <img
            :src="`${cdnLink.CDN_URL}/packet/close.png`"
            alt=""
            :class="$style.close"
            @click="dialogVisible = false"
          />
        </header>
        <main>
          <!-- 弹窗类型 9 -->
          <div v-if="dialogType === 9">
            <div :class="$style.dialogTitle">
              恭喜免费获得{{ turntableInfo.num }}次抽奖机会
            </div>
            <p style="text-align: center">
              活动期间每天来活动页面均可免费 领取{{
                turntableInfo.num
              }}次抽奖机会，
            </p>
            <p style="text-align: center">明天也记得来免费抽奖呦～</p>
            <div :class="$style.btnGroup">
              <button @click="dialogVisible = false" :class="$style.sureBtn">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
          <!-- 弹窗类型 礼包 -->
          <div v-if="dialogType === 0">
            <img :class="$style.dialogImg" :src="drawResult.prizeIcon" />
            <div :class="$style.dialogTitle">{{ drawResult.prizeName }}</div>
            <p style="text-align: center">{{ drawResult.giftDetail }}</p>
            <p style="text-align: center">适用游戏:{{ drawResult.appName }}</p>
            <p style="text-align: center">礼包码已存放在</p>
            <div style="text-align: center">
              【我的】—【我的礼包】—【活动礼包】
            </div>
            <div :class="$style.btnGroup">
              <button @click="onGoGiftDetail" :class="$style.cancelBtn">
                {{ dialogBtnText[dialogType].cancel }}
              </button>
              <button :class="`${$style.sureBtn}`" @click="onContinueDraw(1)">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
          <!-- 现金红包 -->
          <div v-if="dialogType === 1">
            <img :class="$style.dialogImg" :src="drawResult.prizeIcon" />
            <div :class="$style.dialogTitle">{{ drawResult.prizeName }}</div>
            <p style="text-align: center">请联系客服兑换</p>
            <div :class="$style.btnGroup">
              <button @click="onRelationServer" :class="$style.sureBtn">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
          <!-- 弹窗类型 礼包码错误 -->
          <div v-if="dialogType === 2">
            <p>兑换码生成错误，请联系客服领取备用码</p>
            <div :class="$style.btnGroup">
              <button @click="dialogVisible = false" :class="$style.cancelBtn">
                {{ dialogBtnText[dialogType].cancel }}
              </button>
              <button @click="onRelationServer" :class="$style.sureBtn">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
          <!-- 弹窗类型 礼包码错误 -->
          <div v-if="dialogType === 3">
            <p>{{ curTask.taskDesc }}</p>
            <div :class="$style.btnGroup">
              <button
                @click="onGoGameDetail({ ...gameInfo, type: 3 })"
                :class="$style.sureBtn"
              >
                去完成
              </button>
            </div>
          </div>

          <!-- 弹窗类型 礼包码错误 -->
          <div v-if="dialogType === 4">
            <p>{{ curTask.taskDesc }}</p>
            <div :class="$style.progress">
              <p
                :class="$style.percentage"
                :style="{ width: percentage + '%' }"
              ></p>
              <p
                v-if="percentage < 100"
                :class="$style.amount"
                :style="{ left: percentage + '%' }"
              >
                {{ taskInfo.amount }}元
              </p>
              <p :class="$style.typeValue">{{ curTask.typeValue }}元</p>
            </div>
            <div :class="$style.btnGroup">
              <button
                @click="onGoGameDetail({ ...gameInfo, type: 4 })"
                :class="$style.sureBtn"
              >
                去完成
              </button>
            </div>
          </div>

          <!-- 弹窗类型 奖品明细 -->
          <div v-if="dialogType === 5" :class="$style.giftDetailWrapper">
            <div
              v-for="item in giftDetail"
              :key="item.id"
              :class="$style.giftDetail"
            >
              <img
                :class="$style.detailIcon"
                :src="cdnLink.CDN_URL_1 + `/box_turntable/detailIcon.png`"
              />
              <div :class="$style.infoBox">
                <div :class="$style.name">{{ item.prizeName }}</div>
                <div :class="$style.detail">{{ item.giftDetail }}</div>
              </div>
            </div>
            <div :class="$style.btnGroup">
              <button @click="dialogVisible = false" :class="$style.sureBtn">
                我知道了
              </button>
            </div>
          </div>
          <!-- 弹窗类型 代金券 -->
          <div v-if="dialogType === 6">
            <img :class="$style.dialogImg" :src="drawResult.prizeIcon" />
            <div :class="$style.dialogTitle">{{ drawResult.prizeName }}</div>
            <p style="text-align: center">代金券已存放在</p>
            <div style="text-align: center">【我的】—【代金券】</div>
            <div :class="$style.btnGroup">
              <button @click="onGoVoucherDetail" :class="$style.cancelBtn">
                {{ dialogBtnText[dialogType].cancel }}
              </button>
              <button :class="`${$style.sureBtn}`" @click="onContinueDraw(5)">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
          <!-- 弹窗类型 积分 -->
          <div v-if="dialogType === 7">
            <img :class="$style.dialogImg" :src="drawResult.prizeIcon" />
            <div :class="$style.dialogTitle">{{ drawResult.prizeName }}</div>
            <div style="text-align: center">
              积分可用于在【积分商城】兑换游戏道具
            </div>
            <div :class="$style.btnGroup">
              <button @click="onGoCreditDetail" :class="$style.cancelBtn">
                {{ dialogBtnText[dialogType].cancel }}
              </button>
              <button :class="`${$style.sureBtn}`" @click="onContinueDraw(6)">
                {{ dialogBtnText[dialogType].submit }}
              </button>
            </div>
          </div>
        </main>
      </div>
      <div :class="$style.mask" v-if="dialogVisible"></div>
    </div>
  </PullRefresh>
</template>

<script>
import { CDN_URL_1, CDN_URL } from "@/config";
import { ACTIVITY_NAME } from "./config";
import { burnPoint } from '@/apis/heziShare'
import {
  // sendPoint,
  getPlaceBannerApi,
  getPlaceInfoApi,
  getDrawTurntableApi,
  getTaskListApi,
  getCompleteTaskApi,
} from "@/apis/wxActivity";
import { setPageTitle, toLogin, jumpToNative } from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";

export default {
  data() {
    return {
      defaultConfig: {
        // offsetDegree: -22.5,
        speed: 10,
      },
      prizes: [],
      buttons: [
        {
          radius: "25%",
          imgs: [
            {
              src: `${CDN_URL_1}/box_turntable/turntableBtn.png`,
              width: "72px",
              top: "-46px",
            },
          ],
        },
      ],
      cdnLink: { CDN_URL_1, CDN_URL },
      taskList: [], // 任务列表
      dialogVisible: false,
      dialogType: 9, // 9:当日免费 0:礼包 1:现金红包 2:礼包码不足 3：任务内容 4：任务 5：奖品明细 6：代金券 7：积分
      dialogBtnText: {
        9: { cancel: "", submit: "开心收下", title: "系统提示" },
        0: { cancel: "查看礼包", submit: "继续抽奖", title: "恭喜您获得" }, //
        1: { cancel: "", submit: "联系客服", title: "恭喜您获得" },
        2: { cancel: "取消", submit: "联系客服", title: "系统提示" },
        3: { title: "任务未完成" },
        4: { title: "任务未完成" },
        5: { title: "奖品明细" },
        6: { cancel: "查看代金券", submit: "继续抽奖", title: "恭喜您获得" },
        7: { cancel: "去使用积分", submit: "继续抽奖", title: "恭喜您获得" },
      },
      curNum: 0, // 当前抽奖次数
      wheelActivityId: null,
      gameInfo: { appName: "", logo: "", tags: [] },
      turntableInfo: {
        username: "",
        appContent: "",
        num: "",
        residueNum: "",
        positions: [],
      },
      drawResult: {}, // 抽奖结果
      pageTitle: ACTIVITY_NAME,
      curTask: {},
      percentage: 0,
      taskInfo: {},
      deviceInfo: null,
      isLoading: false,
    };
  },
  components: { PullRefresh },
  computed: {
    giftDetail: function () {
      const { positions } = this.turntableInfo;
      let arr = [];
      for (const item of positions) {
        if (item.prizeType !== 2) {
          arr.push(item);
        }
      }
      return arr;
    },
    blocks () {
      return [
        {
          padding: "13px",
          background: "#FF7330",
          imgs: [
            {
              src: `${CDN_URL_1}/box_turntable/${this.prizes.length || 3}.png`,
              width: "100%",
              height: "100%",
              rotate: true,
            },
          ],
        },
      ]
    },
    activityId () {
      return this.$route.query ? this.$route.query.id : ''
    },
    trackParams () {
      return {
        activity_id: this.activityId,
        activity_name: this.gameInfo.activityName,
        activity_game_id: this.wheelActivityId,
      }
    }
  },
  activated() {
    this.dialogVisible = false;
    setPageTitle(this.pageTitle);
    this.initPage();
  },
  created() {
    // 页面数据初始化
  },
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPage();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event)
      burnPoint({
        ...this.deviceInfo,
        ...data,
        appkey: this.gameInfo.gameId,
        appName: this.gameInfo.appName,
      }).catch((err) => console.log(err));
    },
    // 执行初始化操作
    initPage() {
      // 获取设备信息
      const deviceInfoData = localStorage.getItem("deviceInfo");
      this.deviceInfo = JSON.parse(deviceInfoData);
      const { history } = this.$router;
      const { params } = history.current;
      setPageTitle(this.pageTitle);
      if (params.wheelActivityId) {
        this.wheelActivityId = params.wheelActivityId;
        localStorage.setItem("wheelActivityId", params.wheelActivityId);
        // 获取游戏信息
        this.getGameInfo(params.wheelActivityId).then(() => {
          // 获取每日免费抽奖机会
          this.checkDayFirstShowPage(params.wheelActivityId);
        })
        this.getTaskList(params.wheelActivityId);
      }
      if (!this.wheelActivityId && !params.wheelActivityId) {
        this.wheelActivityId = localStorage.getItem("wheelActivityId");
      }
      if (!params.wheelActivityId && this.wheelActivityId) {
        this.getGameInfo(this.wheelActivityId).then(() => {
          this.checkDayFirstShowPage(this.wheelActivityId);
        })
        this.getTaskList(this.wheelActivityId);
      }
    },
    // 检查是否当日首次进入页面
    checkDayFirstShowPage(id) {
      getPlaceInfoApi({ activityGameId: id }).then((res) => {
        this.turntableInfo = res.data;
        this.curNum = res.data.residueNum;
        let prizeArray = [];
        for (const position of res.data.positions) {
          prizeArray.push({
            fonts: [
              {
                text: position.prizeName,
                top: "10%",
                fontSize: 12,
                fontColor: "#e87016",
                fontWeight: 500,
              },
            ],
            imgs: [
              {
                src: position.prizeIcon,
                // src: 'https://image.hzwxbz2.cn/btbox/2023/pic/jyy_1694773730486_1356f6650242460af192e1abfa2c8922.png',
                width: 35,
                top: "42%",
              },
            ],
          });
        }
        // this.prizes = []
        // for (let i = 0; i < 8; i++) {
        //   const it = prizeArray[0]
        //   this.prizes.push({
        //     ...it,
        //     id: i,
        //   })
        // }
        this.prizes = prizeArray;
        if (res.data.isFirst) {
          this.dialogVisible = true;
          this.dialogType = 9;
          this.eventTrack({
            event: "turntable_h5_pop_chance",
            event_field: JSON.stringify({
              is_play: 1,
              residue_times: res.data.residueNum,
              add_times: res.data.num,
              ...this.trackParams,
            }),
          });
        }
      });
    },
    getGameInfo(id) {
      return getPlaceBannerApi({ activityGameId: id }).then((res) => {
        this.gameInfo = res.data;
        this.eventTrack({
          event: "turntable_h5_page",
          event_field: JSON.stringify({
            is_play: 1,
            ...this.trackParams,
          }),
        });
      });
    },
    getTaskList(id) {
      getTaskListApi({ activityGameId: id }).then((res) => {
        this.taskList = res.data.map((item) => {
          let type = "";
          if (item.taskType === 0) {
            type = "选角进入游戏";
          }
          if (item.taskType === 1) {
            type = "充值任意金额";
          }
          if (item.taskType === 2) {
            type = `充值金额达${item.typeValue}元`;
          }
          item.type = type;
          return item;
        });
      });
    },
    // 查看奖品明细
    onRewardDetail() {
      this.dialogType = 5;
      this.dialogVisible = true;
      this.eventTrack({
        event: "turntable_h5_prize_info_list",
        event_field: JSON.stringify({
          is_play: 1,
          ...this.trackParams,
        }),
      });
    },
    // 跳转页面
    onNavigateToPage(page) {
      let path = "";
      let event = "";

      if (page === "活动规则") {
        event = "turntable_h5_rule";
        path = "wxActRule";
      }
      if (page === "领取记录") {
        event = "turntable_h5_prize_log";
        path = "wxActRecords";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({
          is_play: 1,
          ...this.trackParams,
        }),
      });
      this.$router.push({
        name: `box.${path}`,
        query: { id: this.activityId },
        params: {
          // 活动会场ID
          gameId: this.wheelActivityId,
        },
      });
    },
    // 点击抽奖按钮会触发star回调
    async startCallback() {
      if (this.curNum <= 0 || !this.wheelActivityId) {
        this.$toast("剩余抽奖次数不足");
        return;
      }
      this.eventTrack({
        event: "turntable_h5_begin_icon",
        event_field: JSON.stringify({
          is_play: 1,
          residue_times: this.curNum,
          ...this.trackParams,
        }),
      });

      try {
        const { data } = await getDrawTurntableApi({
          activityGameId: this.wheelActivityId,
        });
        this.curNum -= 1;
        // 调用抽奖组件的play方法开始游戏
        this.$refs.myLucky.play();
        setTimeout(() => {
          const index = data.position - 1;
          // 调用stop停止旋转并传递中奖索引
          this.$refs.myLucky.stop(index);
          this.drawResult = data;
          this.curNum = data.residueNum;
        }, 4500);
      } catch (error) {
        if (error.code === 1036) {
          this.$toast("获取用户信息失败  请重试");
        }
        let errorInfo = error.response || {}
        const { data } = errorInfo;
        if (data && data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
        }
      }
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      const { prizeType, cdk, giftId, prizeName, residueNum } = this.drawResult;
      setTimeout(() => {
        let prize_type = 1;
        if (prizeType === 0) {
          // 礼包
          if (cdk) {
            this.dialogType = 0;
          } else {
            this.dialogType = 2;
            prize_type = 2;
          }
          this.dialogVisible = true;
        }
        if (prizeType === 1) {
          // 现金红包
          this.dialogVisible = true;
          this.dialogType = 1;
          prize_type = 3;
        }
        if (prizeType === 2) {
          // 谢谢惠顾
          this.$toast("很遗憾，本次未中奖");
          prize_type = 4;
        }
        if (prizeType === 3) {
          // 代金券
          this.dialogVisible = true;
          this.dialogType = 6;
          prize_type = 5;
        }
        if (prizeType === 4) {
          // 积分
          this.dialogType = 7;
          prize_type = 6;
          this.dialogVisible = true;
        }
        this.eventTrack({
          event: "turntable_h5_pop_result",
          event_field: JSON.stringify({
            is_play: 1,
            prize_id: giftId,
            prize_name: prizeName,
            residue_times: residueNum,
            prize_type: prize_type,
            ...this.trackParams,
          }),
        });
      }, 500);
    },
    // 礼包详情
    onGoGiftDetail() {
      this.dialogVisible = false;
      this.eventTrack({
        event: "turntable_h5_pop_look_code",
        event_field: JSON.stringify({
          prize_id: this.drawResult.giftId,
          prize_name: this.drawResult.prizeName,
          ...this.trackParams,
        }),
      });
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 代金券
    onGoVoucherDetail() {
      this.eventTrack({
        event: "turntable_h5_pop_look_voucher",
        event_field: JSON.stringify({
          prize_id: this.drawResult.giftId,
          prize_name: this.drawResult.prizeName,
          ...this.trackParams,
        }),
      });
      this.dialogVisible = false;
      const data = {
        routePath: "/coupon/CouponManageActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    //  积分商城
    onGoCreditDetail() {
      this.eventTrack({
        event: "turntable_h5_pop_use_credit",
        event_field: JSON.stringify({
          prize_id: this.drawResult.giftId,
          prize_name: this.drawResult.prizeName,
          ...this.trackParams,
        }),
      });
      this.dialogVisible = false;
      const data = {
        routePath: "/task/CreditStoreActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 继续抽奖
    onContinueDraw(type) {
      this.dialogVisible = false;
      this.eventTrack({
        event: "turntable_h5_pop_draw_continue",
        event_field: JSON.stringify({
          prize_id: this.drawResult.giftId,
          prize_name: this.drawResult.prizeName,
          type,
          ...this.trackParams,
        }),
      });
    },
    // 游戏详情
    onGoGameDetail({ gameId, type, prizeName, giftId, activityName }) {
      if (type === 1) {
        this.eventTrack({
          event: "turntable_h5_game_scan",
          event_field: JSON.stringify({
            is_play: 1,
            ...this.trackParams,
          }),
        });
      }
      if (type === 3 || type === 4) {
        let task_type = 1;
        if (type === 4) {
          task_type = 2;
        }
        this.eventTrack({
          event: "turntable_h5_get_times_goto_finish",
          event_field: JSON.stringify({
            is_play: 1,
            task_type: task_type,
            task_id: this.curTask.id,
            task_name: this.curTask.taskName,
            ...this.trackParams,
          }),
        });
      }

      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: gameId,
        fromPageType: 19,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
      this.dialogVisible = false;
    },
    // 联系客服
    onRelationServer() {
      this.dialogVisible = false;
      this.eventTrack({
        event: "turntable_h5_pop_linkme",
        event_field: JSON.stringify({
          is_play: 1,
          prize_id: this.drawResult.giftId,
          prize_name: this.drawResult.prizeName,
          prize_type: this.drawResult.prizeType,
          ...this.trackParams,
        }),
      });
      localStorage.setItem("wheelActivityId", this.wheelActivityId);
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 完成任务
    onCompleteTask(task) {
      const { id, typeValue, receiveStatus } = task;
      this.curTask = task;
      if (receiveStatus == 1) {
        return
      }
      getCompleteTaskApi({ taskId: id })
        .then((res) => {
          const { hasComplete, taskType, amount, residueNum, rewardNum } =
            res.data;
          this.taskInfo = res.data;
          this.curNum = residueNum;
          // 数据上报
          this.eventTrack({
            event: "turntable_h5_get_times",
            event_field: JSON.stringify({
              is_play: 1,
              task_id: task.id,
              task_name: task.taskName,
              task_status: hasComplete ? 1 : 2,
              add_times: rewardNum,
              residue_times: residueNum,
              ...this.trackParams,
            }),
          });

          if (hasComplete) {
            this.$toast(`抽奖次数+${rewardNum}`);
            this.getTaskList(this.wheelActivityId);
            return;
          }
          let task_type = "";
          if (taskType === 0 || taskType === 1) {
            this.dialogType = 3;
            task_type = 1;
          } else {
            this.percentage = Math.round(100 * (amount / typeValue));
            this.dialogType = 4;
            task_type = 2;
          }
          this.dialogVisible = true;
          this.eventTrack({
            event: "turntable_h5_get_times_pop",
            event_field: JSON.stringify({
              is_play: 1,
              task_type: task_type,
              task_id: task.id,
              task_name: task.taskName,
              ...this.trackParams,
            }),
          });
        })
        .catch((error) => {
          let errorInfo = error.response;
          const { data } = errorInfo;
          if (data && data.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
    },
  },
};
</script>
<style lang="scss" module>
.btLuckyTurntable {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #fc4d44;
  position: relative;
  .pageBack {
    width: 100%;
    height: 100vh;
    z-index: 1;
  }
  .pageContent {
    margin: 0 auto;
    // top: 0;
    // left: 0;
    // right: 0;
    // position: absolute;
    // z-index: 2;
    .gameBox {
      width: 94%;
      margin: 10px auto 0;
      height: 80px;
      background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
      border-radius: 11.11px;
      align-items: center;
      justify-content: space-around;
      display: flex;
      border: solid 6px #fe6057;
      box-shadow: 1px 1px 3.13px 0.1px #c21000;
      padding: 0 8px;
      .icon {
        width: 48px;
        height: 48px;
      }
      .info {
        flex: 1;
        margin: 0 7px;
        .categoryNames {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #ff7a2a;
          line-height: 12px;
        }
        .tags {
          > span {
            background-color: #f2c29e;
            padding: 1px 2px;
            font-size: 12px;
            margin-right: 2px;
          }
        }
        .name {
          font-size: 13px;
          font-weight: 600;
          text-align: left;
          color: #666666;
          line-height: 13px;
          margin-bottom: 8px;
        }
      }
      .download {
        width: 82px;
        height: 28px;
        background: linear-gradient(0deg, #d12c31 0%, #f77c4e 100%);
        border: 1.04px solid #ffe19c;
        border-radius: 3.47px;
        font-weight: 400;
        font-size: 13px;
        text-align: center;
        color: #ffe19c;
      }
    }
    .luckyWheelBox {
      width: 94%;
      margin: 10px auto 0;
      padding-bottom: 20px;
      min-height: 450px;
      background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
      border-radius: 11.11px;
      flex-direction: column;
      align-items: center;
      display: flex;
      border: solid 6px #fe6057;
      box-shadow: 1px 1px 3.13px 0.1px #c21000;
      position: relative;
      .userInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 11px 13px;
        .account {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 14px;
        }
        .info {
          font-size: 13px;
          font-weight: 400;
          text-align: center;
          line-height: 13px;
          a {
            color: #666666;
            border-bottom: 1px solid;
            margin-left: 13px;
          }
        }
      }
      .notice {
        width: 260px;
        height: 28px;
        background: #fd7e79;
        border-radius: 14px;
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 28px;
        white-space: nowrap;
        padding: 0 17px;
        overflow: hidden;
        margin: 4px 0 13px;
        div {
          position: relative;
          p {
            position: absolute;
            animation: noticeMove 10s infinite linear;
          }
        }

        @keyframes noticeMove {
          0% {
            transform: translateX(100%);
          }
          25% {
            transform: translateX(50%);
          }
          50% {
            transform: translateX(0%);
          }
          75% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      }
      .drawNum {
        font-size: 19px;
        font-weight: 700;
        text-align: center;
        color: #fc5f5e;
        line-height: 19px;
        margin-top: 4px;
      }
      .desc {
        margin: 6px 0 20px;
        width: 250px;
        height: 12px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #fc5f5e;
        line-height: 12px;
      }
      .rewardInfo {
        position: absolute;
        right: 13px;
        bottom: 50px;
        border-bottom: 1px solid;
        margin-left: 13px;
        font-size: 13px;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 14px;
      }
    }
    .taskBox {
      width: 94%;
      margin: 10px auto 10px;
      padding-bottom: 20px;
      min-height: 100px;
      // min-height: 400px;
      background: linear-gradient(0deg, #fcd990 0%, #f3935a 100%);
      border: 0.35px solid #ffda8a;
      border-radius: 11.11px;

      box-shadow: 1px 1px 3.13px 0.1px #c21000;
      .task {
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 11px 13px 0;
        .taskIcon {
          width: 35px;
          height: 35px;
          border-radius: 8px;
        }
        .taskInfo {
          flex: 1;
          margin: 0 8px;
          .taskType {
            font-size: 16px;
            font-weight: 500;
            text-align: left;
            color: #833d13;
            line-height: 16px;
            margin-bottom: 4px;
          }
          .num {
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: #dc4026;
            line-height: 12px;
          }
        }
        .taskBtn {
          width: 88px;
          height: 30px;
          background: linear-gradient(-36deg, #ffba16 0%, #ffd669 100%);
          border-radius: 12px;
          box-shadow: 0px -2px 0px 2px rgba(255, 182, 118, 0.5) inset;
          border: none;

          font-size: 12px;
          font-weight: 500;
          text-align: center;
          color: #469646;
          margin: 15px 0;
        }
        .statusBtn {
          filter: grayscale(1);
        }
      }
    }
  }
  .dialog {
    width: 306px;
    min-height: 200px;
    position: fixed;
    top: 32%;
    left: 0;
    right: 0;
    // bottom: 0;
    margin: auto;
    background-color: #ffffff;
    z-index: 100;
    border-radius: 4px;
    overflow: hidden;
    > header {
      display: flex;
      background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
      font-size: 19px;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      height: 37px;
      .close {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 16px;
        height: 16px;
      }
    }
    > main {
      text-align: center;
      padding: 20px 0 70px;
      .bt {
        font-size: 18px;
        font-weight: 700;
        color: #ff612c;
        margin-bottom: 30px;
        text-align: center;
      }
      p {
        width: 230px;
        margin: auto;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        > span {
          color: #ff612c;
        }
      }
      .hint {
        font-size: 13px;
        color: #666666;
      }
    }
    .btnGroup {
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: center;
      width: 80%;
      left: 0;
      right: 0;
      margin: auto;
      > button {
        border: none;
        outline: none;
        width: 105px;
        height: 35px;
        font-size: 13px;
        border-radius: 35px;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        &:active {
          opacity: 0.8;
        }
      }
      .cancelBtn {
        background: #fff2f2;
        color: #fc5f5e;
        margin-right: 28px;
      }
      .sureBtn {
        background: #fd383c;
        color: #ffffff;
      }
    }
    .dialogTitle {
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ff612c;
      line-height: 27px;
      margin-bottom: 10px;
    }
    .dialogImg {
      // width: 68px;
      height: 54px;
    }
    .progress {
      height: 16px;
      // background: #d43e41;
      border-radius: 8px;
      border: 1px solid #d43e41;
      width: 80%;
      margin: 20px auto 0;
      position: relative;
      .percentage {
        height: 14px;
        position: absolute;
        left: 1px;
        top: 0;
        bottom: 0;
        background: linear-gradient(#ff756a 0%, #ffb46b 100%);
        border-radius: 6px;
      }
      .amount {
        font-size: 13px;
        color: #ff756a;
        font-weight: 500;
        position: absolute;
        top: -20px;
      }
      .typeValue {
        font-size: 13px;
        color: #ffb46b;
        font-weight: 500;
        position: absolute;
        right: -8px;
        top: 15px;
        width: auto;
      }
    }
    .giftDetailWrapper {
      max-height: 260px;
      overflow: auto;
    }
    .giftDetail {
      padding: 3px 12px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      // justify-content: space-between;
      .detailIcon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        margin-left: 12px;
      }
      .infoBox {
        flex: 1;
        text-align: left;
      }
      .name {
        font-size: 14px;
        color: #fc5f5e;
        line-height: 20px;
      }
      .detail {
        font-size: 12px;
        color: #666666;
        line-height: 16px;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
  }
}
</style>
